import { ParentComponent } from 'solid-js'

interface Props {
  // store: FormLabelStore,
  /**
   * @link https://github.com/solidjs/solid/discussions/1737#discussioncomment-7223583
   */
  class?: string,
}

const FormLabel: ParentComponent<Props> = (props) => {
  return <label
    class="form-label"
    classList={{ [props.class as string]: !!props.class }}
  >
    {props.children}
  </label>
}

export default FormLabel